/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesAttributeDTO } from './SeriesAttributeDTO';
import {
    SeriesAttributeDTOFromJSON,
    SeriesAttributeDTOFromJSONTyped,
    SeriesAttributeDTOToJSON,
} from './SeriesAttributeDTO';

/**
 * 
 * @export
 * @interface SeriesPointSourceRequestDTO
 */
export interface SeriesPointSourceRequestDTO {
    /**
     * 
     * @type {Array<SeriesAttributeDTO>}
     * @memberof SeriesPointSourceRequestDTO
     */
    attributes: Array<SeriesAttributeDTO>;
    /**
     * 
     * @type {number}
     * @memberof SeriesPointSourceRequestDTO
     */
    step: number;
}

/**
 * Check if a given object implements the SeriesPointSourceRequestDTO interface.
 */
export function instanceOfSeriesPointSourceRequestDTO(value: object): value is SeriesPointSourceRequestDTO {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('step' in value) || value['step'] === undefined) return false;
    return true;
}

export function SeriesPointSourceRequestDTOFromJSON(json: any): SeriesPointSourceRequestDTO {
    return SeriesPointSourceRequestDTOFromJSONTyped(json, false);
}

export function SeriesPointSourceRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesPointSourceRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributes': ((json['attributes'] as Array<any>).map(SeriesAttributeDTOFromJSON)),
        'step': json['step'],
    };
}

export function SeriesPointSourceRequestDTOToJSON(value?: SeriesPointSourceRequestDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributes': ((value['attributes'] as Array<any>).map(SeriesAttributeDTOToJSON)),
        'step': value['step'],
    };
}

